export default {"src":"/_next/static/image/public/images/flags/flag_972.5d50f497868eb77c1d84c6da086f5562.svg","height":16,"width":24};